module.exports = __webpack_public_path__ + "img/744.6c0cdddb.jpg";